import { render, staticRenderFns } from "./MedicineSummaryScore.vue?vue&type=template&id=1155ac26"
import script from "./MedicineSummaryScore.vue?vue&type=script&lang=js"
export * from "./MedicineSummaryScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports